// Packages
import React from 'react'
// Antd
import { Row, Col } from 'antd'
// Images
import emailIcon from '../../public/img/email.svg'
import whatappIcon from '../../public/img/whatsapp.svg'
import { Applicant } from './ProfileDownload'

type Props = {
  applicant: Applicant;
};
const ProfileContact = ({ applicant }: Props) => {
	const { contact, email, whatsapp } = applicant
	return (
		<>
			<Row>
				<Col>
					<h4 style={{ color: '#9b9b9b' }}>Contact Details</h4>
				</Col>
			</Row>
			<Row>
				{contact ? <Col>{contact}</Col> : null}
				{email ? (
					<Col style={{ marginRight: 5 }}>
            &nbsp;|&nbsp;
						<img src={emailIcon} alt="emailIcon" style={{ width: '1rem' }} />
            &nbsp;{email}
					</Col>
				) : null}
				{whatsapp ? (
					<Col>
            &nbsp;|&nbsp;
						<img
							src={whatappIcon}
							alt="whatsappIcon"
							style={{ width: '1rem' }}
						/>
            &nbsp;{whatsapp}
					</Col>
				) : null}
			</Row>
		</>
	)
}

export default ProfileContact
